import React, { Component } from "react";
import "../assets/css/DonationComponent.css";
import "../assets/css/responsive.css";
import Spinner from "../Spinner";
import { ToastContainer, toast } from "react-toastify";
import Navbar from "./Navbar"
import Footer from "./Footer";
import RegistrationForm from "./RegistrationForm";
import BlueSection from "./BlueSection";
import { ReactComponent as BackgroundSVG } from "../assets/img/background2.svg";
import axios from "axios";

class RegistrationComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      currentURL: "",
      data: [],
    };
  }

  updateIsLoading = (state) => {
    this.setState({ isLoading: state });
  };

  updateHasDonated = (state) => {
    this.setState({ hasDonated: state });
  };

  updateAmount = (amount) => {
    this.setState({ amount: amount });
  };

  togglePayFees = (e) => {
    this.setState({ payFees: !this.state.payFees });
  };

  componentDidMount() {
    this.setState({ currentURL: window.location.href });

    this.fetchData();
  }

  // Fetch transaction data from the API
  fetchData = async () => {
    try {
      this.setState({ isLoading: true });
      // Make API call to fetch transaction data
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/attendees/${this.props.url_query}`
      );

      // Update state with fetched data
      this.setState({ data: response.data, isLoading: false }, () => {
        window.scrollTo(0, 0);
        console.log(this.state.attendees);
      });
    } catch (error) {
      // Handle errors
      this.setState({ error: error.message, isLoading: false });
    }
  };

  updateFirstName = (firstName) => {
    this.setState({ firstName: firstName });
  };

  updateTicketOption = (value, identifier) => {
    this.setState({ [identifier]: value });
  };

  updateTicketQuantity = (e) => {
    e.preventDefault();
    this.setState({ ticketQty: e.target.value });
  };

  updateRegistrationURL = (value) => {
    this.setState({ registrationURL: value });
  };

  render() {
    return (
      <>
        <BlueSection />
        <div className="donation-area bg-gray default-padding">
          {/* Fixed BG */}
          <Navbar />
          <div
            className={
              this.state.currentURL.includes("monthly")
                ? "fixed-bg monthly"
                : "fixed-bg"
            }
            id="bg-wrap"
          >
            <BackgroundSVG />
          </div>
          {/* End Fixed BG */}
          <div className="container">
            <div className="row mt-5">
              <div className="col-lg-6 info"></div>
              <div className="col-lg-6 info text-light donation-form">
                <RegistrationForm
                  updateIsLoading={this.updateIsLoading}
                  attendees={this.state.data}
                  fetchData={this.fetchData}
                />
              </div>
            </div>
          </div>
        </div>
        {this.state.isLoading && <Spinner />}
        <ToastContainer />
        <Footer />
      </>
    );
  }
}

export default RegistrationComponent;
